export default {
  region: { name: 'Région', order: 1 },
  department: { name: 'Département', order: 2, parent: 'region', hierarchy: 2 },
  city: { name: 'Ville', order: 3, parent: 'department', hierarchy: 3 },
  category: { name: 'Catégorie', order: 4 },
  subcategory: { name: 'Sous-catégorie', order: 5 },
  typeprojet: { name: 'Type de projet', order: 6 },
  destinationprojet: { name: 'Destination du bien', order: 7 }
};
